/*
 Matches the ColumnName class from the server.
*/
class ColumnName {
  readonly _alias: string;

  readonly _name: string;

  constructor(alias: string, name: string) {
    this._alias = alias;
    this._name = name;
  }

  static build(columnNameFromServer: ColumnName) {
    return new ColumnName(
      columnNameFromServer._alias,
      columnNameFromServer._name,
    );
  }

  alias = () => this._alias;

  hasAlias = () => !!this.alias();

  name = () => this._name;

  equals(c: Nullable<ColumnName>) {
    if (!c) {
      return false;
    }
    if (this._alias !== c._alias) {
      return false;
    }
    return this._name === c._name;
  }

  compareTo(other: ColumnName) {
    if (other.alias() !== this.alias()) {
      if (!other.alias()) {
        return -1;
      }
      if (this.alias() === null) {
        return 1;
      }
      return other.alias().localeCompare(this.alias());
    }
    return other.name().localeCompare(this.name());
  }

  toString() {
    if (!this.hasAlias()) {
      return this.name();
    }
    return `${this.alias()}.${this.name()}`;
  }
}

export default ColumnName;
